var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-p-3 tw-mt-2",attrs:{"theme":"danger"}},[_vm._v(" There are no leave types available for you to request. Please contact your administrator to make one available. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }